import { FaCode, FaCog, FaSearchengin } from "react-icons/fa"

export const ServicesList = [
  {
    id: 1,
    title: "Web Development",
    text: "Building a website that can help you define your brand and increase your products/services demand through a customer-centric and data-driven approach.",
    icon: FaCode,
  },
  {
    id: 2,
    title: "Search Engine Optimization",
    text: "I'll make sure to optimize your site in a manner where your clients find you based on genuine searches and keywords.",
    icon: FaSearchengin,
  },
  {
    id: 3,
    title: "Web Optimization",
    text: "Web optimization is the process of making web apps more user-friendly and visible to search engines.",
    icon: FaCog,
  },
]
